import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined"
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined"
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined"
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"
import { Box, Chip, Stack, Typography } from "@mui/material"

import { LIGHT_BLUE, PRIMARY } from "@constants/colors"
import {
  ChangelogSection,
  useChangelogPageContext
} from "@contexts/main/changelog_page_context"

export default function ChangelogPageLeftDrawer() {
  const { translate, activeSection, setActiveSection, announcements } =
    useChangelogPageContext()

  const items: {
    key: ChangelogSection
    label: string
    icon: JSX.Element
    count?: number
  }[] = [
    {
      key: "announcements",
      label: translate("changelog_announcements"),
      icon: <CampaignOutlinedIcon fontSize="small" />,
      count: announcements.length
    },
    {
      key: "categories",
      label: translate("changelog_categories"),
      icon: <LocalOfferOutlinedIcon fontSize="small" />
    },
    {
      key: "subscribers",
      label: translate("changelog_subscribers"),
      icon: <PeopleAltOutlinedIcon fontSize="small" />
    },
    {
      key: "deliveries",
      label: translate("changelog_deliveries"),
      icon: <ReceiptLongOutlinedIcon fontSize="small" />
    },
    {
      key: "settings",
      label: translate("changelog_settings"),
      icon: <SettingsOutlinedIcon fontSize="small" />
    }
  ]

  return (
    <Box
      sx={{
        width: "15rem",
        minWidth: "15rem",
        maxWidth: "15rem",
        height: "100%",
        borderRight: 1,
        borderColor: "divider",
        background: "white",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box sx={{ p: 2, pb: 1 }}>
        <Typography
          sx={{
            fontSize: "0.72rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: "text.secondary"
          }}
        >
          {translate("changelog_tooltip").toUpperCase()}
        </Typography>
      </Box>

      <Stack sx={{ px: 1.5, gap: 0.25 }}>
        {items.map((item) => {
          const isActive = activeSection === item.key
          return (
            <Stack
              key={item.key}
              direction="row"
              alignItems="center"
              onClick={() => setActiveSection(item.key)}
              sx={{
                cursor: "pointer",
                px: 1.5,
                py: 1,
                borderRadius: 1.5,
                color: isActive ? PRIMARY : "text.primary",
                background: isActive ? LIGHT_BLUE : "transparent",
                transition: "background 0.15s ease",
                ":hover": { background: isActive ? LIGHT_BLUE : "#F7F7F7" }
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: isActive ? PRIMARY : "text.secondary",
                  mr: 1.25
                }}
              >
                {item.icon}
              </Box>
              <Typography
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: isActive ? 600 : 500,
                  flex: 1
                }}
              >
                {item.label}
              </Typography>
              {item.count !== undefined && item.count > 0 && (
                <Chip
                  label={item.count}
                  size="small"
                  sx={{
                    height: "1.25rem",
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    background: isActive ? PRIMARY : "#EEF0F2",
                    color: isActive ? "white" : "text.secondary"
                  }}
                />
              )}
            </Stack>
          )
        })}
      </Stack>
    </Box>
  )
}
